// src/App.jsx
import React, { Suspense, lazy, useState, useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { ThemeProvider } from './context/ThemeContext';
import { AnalyticsProvider } from './context/AnalyticsContext';

// load utils and base components
import UpdateDocumentMeta from './components/utils/DocumentMeta';
import LoadingFallback from './components/ui/LoadingFallback';

// load layout components
import Header from './components/layout/Header';
const Footer = lazy(() => import('./components/layout/Footer'));

// navigation and page component loading
import navigation from './data/navigation';
const lazyPages = {};
navigation.forEach(navItem => {
    const pageName = navItem.path === '/' ? 'Home' : navItem.path.substring(1).charAt(0).toUpperCase() + navItem.path.substring(2);
    lazyPages[navItem.id] = lazy(() => import(`./pages/${pageName}`));
});

const App = () => {
    const [isScrolled, setIsScrolled] = useState(true);

    useEffect(() => {
        const handleScroll = () => {
            const path = window.location.pathname;
            if (path === '/') {
                setIsScrolled(window.scrollY > 0);
            } else {
                setIsScrolled(true);
            }
        };

        window.addEventListener('scroll', handleScroll);
        handleScroll();
        return () => {
            window.removeEventListener('scroll', handleScroll);
        };
    }, []);

    return (
        <ThemeProvider>
            <Router>
                <AnalyticsProvider>
                    <div className="app">
                        <UpdateDocumentMeta />
                        <Header isScrolled={isScrolled} />
                        <div className="content">
                            <Suspense fallback={<LoadingFallback />}>
                                <Routes>
                                    {navigation.map(navItem => {
                                        const PageComponent = lazyPages[navItem.id];
                                        return (
                                            <Route
                                                key={navItem.id}
                                                path={navItem.path}
                                                element={<PageComponent />}
                                                exact={navItem.path === '/'}
                                            />
                                        );
                                    })}
                                </Routes>
                            </Suspense>
                        </div>
                        <Footer />
                    </div>
                </AnalyticsProvider>
            </Router>
        </ThemeProvider>
    );
};

export default App;